/*
 * The deploy tag (e.g. "1.2.24528-develop-mirror7"), read from the
 * `<meta name="app-version">` that server.js stamps at boot. It is no longer a
 * Vite build-time value, so the web bundle does not rebuild on every tag.
 * Undefined under the Vite dev server, where the placeholder is never replaced.
 */
const stamped = typeof document !== "undefined"
    ? document.querySelector<HTMLMetaElement>("meta[name=\"app-version\"]")?.content
    : undefined;

export const APP_VERSION: string | undefined =
    stamped && stamped !== "__APP_VERSION__" ? stamped : undefined;
